import {Component, Fragment, h} from "preact";
import {AcademicProgram} from "../../_api";
import {Link} from "react-router-dom";
import {C} from "../../_common/layout";
import Badge from "../../_common/components/Badge";

type Props = {
    apply: any,
    fixtures: {academic_programs: AcademicProgram[]},
    acceptUnfinished: boolean
}


class ApplicationCard extends Component<Props> {


    render = ({apply, fixtures, acceptUnfinished}: Props) => <div className='card m-top'>
        <div className='p-x2-all'>
            <Link to={`/candidate/${apply.id}`} className='no-decoration font-color-black'><h2 className='font-24'> {apply.name}</h2></Link>
            <div className='p-top'>
                <div className='sm-d-line d-block'>
                    <span className='p-right '>{fixtures.academic_programs[apply.academicProgram]}</span>
                    {(acceptUnfinished) && <Badge type='warning' className='light'><span>{apply.academicProgramPercent}%</span></Badge>}
                </div>
                {   apply.hasKillerGrade && <Fragment>
                    <span className='p-left p-right translucent d-none sm-d-line'>|</span>
                    <div className='sm-d-line d-block'>
                        <span className='p-right'>Cuestionario</span>
                        <Badge type='warning' className='light'><span>{apply.killerGrade}%</span></Badge>
                    </div>
                </Fragment>
                }


                <span className='p-left p-right translucent d-none sm-d-line'>|</span>
                <div className='sm-d-line d-block'>
                    <span className='p-right translucent'>Edad:</span>
                    <span>{apply.age} años</span>
                </div>

            </div>
        </div>
    </div>


};

export default ApplicationCard;
